<template>
  <div>
    <!-- Projects -->
    <section class="section section-lg sec">
      <div class="container-fluid">
        <h1 class="title">OUR PROJECTS</h1>
        <div class="col px-0">
          <div class="row ">
            <div class="col-lg-6 col-md mt-5 mb-0 col-sm mt-0 adj">
              <img class="img-fluid projects" src="/img/projects/optimized/project1.png" alt="" />
            </div>
            <div class="col-lg-6 col-md mt-5 mb-0 col-sm mt-0 adj">
              <div class="linearmeter">
                <h2 class="lm">
                  4,107.37 linear meter installed out of 6,179.80 in Laiya,
                  Batangas
                </h2>
                <p class="description">
                  EHI Precast Fence system may be installed on top of riprap,
                  existing CHB wall, with benching and/or sloping terrains.
                </p>
                <base-button tag="a" href="/contact-us" class="mb-3 mb-sm-0 btn-outline-primary inquire" type="white">
                  INQUIRE NOW
                </base-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!--Real Estate Development-->
    <section class="section-hero section-shaped OPhero1 content">
      <div>
        <h1 class="text-white text-hero">
          Real Estate <br />
          Developments
        </h1>
      </div>
      <div class="d-flex justify-content-end pr-5 display-4 text-white bottom-desc">
        EHI Precast Fence system may be <br />
        installed on top of riprap, existing <br />
        CHB wall, with benching and/or <br />
        sloping terrains.
      </div>
    </section>

    <!--Standard Precast Concrete Fence with Barbed Wire-->
    <section class="section section-lg sec">
      <div class="container-fluid">
        <div class="col px-0">
          <div class="row ">
            <div class="col-lg-6 col-md mt-5 mb-0 col-sm mt-0 adj">
              <div class="linearmeter">
                <h2 class="lm">
                  Standard Precast Concrete Fence with Barbed Wire
                </h2>
                <p class="description">
                  G.I. pipes or angle bars are used as barbed wire provisions
                </p>
                <base-button tag="a" href="/contact-us" class="mb-3 mb-sm-0 text-warning btn-outline-primary inquire"
                  type="white">
                  INQUIRE NOW
                </base-button>
              </div>
            </div>
            <div class="col-lg-6 col-md mt-5 mb-0 col-sm mt-0 adj">
              <img class="img-fluid projects" src="/img/projects/optimized/project2.png" alt="" />
            </div>
          </div>
        </div>
      </div>
    </section>

    <!--Infrastructure Projects-->
    <section class="section-hero section-shaped OPhero2 content">
      <div>
        <h1 class="text-white text-hero">
          Infrastructure <br />
          Projects
        </h1>
      </div>
      <div class="d-flex justify-content-end pr-5 display-4 text-white bottom-desc">
        At Easyhomes, we never sacrifice <br />
        quality – we have a philosophy of <br />
        getting the job done right on time <br />
        and within budget.
      </div>
    </section>

    <!--Infrastructure-->
    <section class="section section-lg sec">
      <div class="container-fluid">
        <div class="col px-0">
          <div class="row ">
            <div class="col-lg-6 col-md mt-5 mb-0 col-sm mt-0 adj">
              <img class="img-fluid projects" src="/img/projects/optimized/project3.png" alt="" />
            </div>
            <div class="col-lg-6 col-md mt-5 mb-0 col-sm mt-0 adj">
              <div class="linearmeter">
                <h2 class="lm">
                  Standard Precast Concrete Fence On Top of Retaining Wall
                </h2>
                <p class="description">
                  Fence system is placed on top of retaining walls.
                </p>
                <base-button tag="a" href="/contact-us" class="mb-3 mb-sm-0 text-warning btn-outline-primary inquire"
                  type="white">
                  INQUIRE NOW
                </base-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "our-projects",
};
</script>

<style lang="scss" scoped>
.OPhero1 {
  position: relative;
  background-image: url("/img/projects/optimized/project-hero1.jpg");
  background-attachment: fixed;
  background-position: 50% 50%;
  background-repeat: no-repeat;
  background-size: cover;
  margin: -95px 0 !important;
}

.OPhero2 {
  position: relative;
  background-image: url("/img/projects/optimized/infra.png");
  background-attachment: fixed;
  background-position: 50% 50%;
  background-repeat: no-repeat;
  background-size: cover;
  margin: -95px 0 !important;
}

.title {
  color: #56594d;
  font-weight: 600;
  font-size: 3rem;
  margin-left: 9rem;
  /* margin-bottom: 10rem; */
}

.sec {
  margin-bottom: 0;
}

.projects {
  height: 40rem;
  width: 10rem;
}

.linearmeter {
  max-width: 66%;
  display: block;
  margin: 120px auto;
}

.lm {
  font-weight: 600;
  color: #4e5152;
  margin: 120px 150px 10px;
}

.description {
  margin-top: 25px;
  font-size: 20px;
  margin-left: 168px;
  line-height: 25px;
  font-weight: 500;
}

.text-hero {
  font-size: 3rem;
  font-weight: 900;
  text-shadow: 2px 2px rgba(0, 0, 0, 0.56);
  padding: 100px 0 0 84px;
}

.inquire {
  border: 1px solid #a7adaf;
  color: #eda711 !important;
  margin-left: 158px;
  width: 15rem;
  margin-top: 20px;
}

.inquire:hover {
  color: white !important;
  background-color: #eda711 !important;
}

.bottom-desc {
  margin-top: 20%;
}

.adj {
  margin-top: 0 !important;
}

.adj img {
  width: 100%;
}

@media only screen and (max-width: 280px) {
  .navbar-brand img {
    height: 45px;
  }

  .inquire[data-v-8f3656c8] {
    margin-left: 20%;
  }

  .bottom-desc {
    padding-left: 20px;
  }
}

/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {

  .OPhero1,
  .OPhero2 {
    margin: 0 !important;
  }

  .title {
    font-size: 2.5rem;
    margin-left: 0rem;
    font-weight: 700;
  }

  .projects {
    height: 20rem;
  }

  .linearmeter {
    max-width: 100%;
    margin: 0;
  }

  .lm {
    font-size: 1.5rem;
    margin: 15px 0px 0px;
  }

  .description {
    margin-left: 0px;
    font-size: 18px;
  }

  .sec {
    padding-bottom: 0;
    padding-top: 20px !important;
  }

  .text-hero {
    font-size: 2rem;
    padding: 24px 0 0 28px !important;
  }

  .bottom-desc {
    margin-top: 90%;
    font-size: 18px;
    font-weight: 100;
    padding-bottom: 15px;
    text-shadow: 2px 2px rgba(0, 0, 0, 0.48);
  }

  .inquire {
    margin-left: 50%;
    width: 10rem;
  }
}

/* Small devices (portrait tablets and large phones, 600px and up) */
@media only screen and (min-width: 600px) {}

/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
  .title {
    font-weight: 700;
    margin-left: 2rem;
  }

  .lm {
    font-size: 1.5rem;
    margin: 33px 0px 10px;
  }

  .projects {
    height: 20rem;
  }

  .linearmeter {
    max-width: 100%;
    margin: 20px 0px;
  }

  .description {
    margin-left: 120px;
  }

  .bottom-desc {
    margin-top: 80%;
    text-shadow: 2px 2px rgba(0, 0, 0, 0.48);
  }

  .inquire {
    margin-left: 205px;
  }
}

/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {
  .lm {
    margin: 30px 65px;
  }

  .bottom-desc {
    margin-top: 20%;
    text-shadow: 2px 2px rgba(0, 0, 0, 0.48);
  }

  .projects {
    height: 25rem;
  }
}

/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1200px) {
  .lm {
    font-size: 2rem;
    margin: 70px 145px 10px;
  }

  .description {
    margin: 20px 105px 0px 292px;
  }

  .bottom-desc[data-v-8f3656c8] {
    margin-top: 20%;
    text-shadow: 2px 2px rgba(0, 0, 0, 0.48);
  }

  .projects {
    height: 35rem;
  }

  .inquire {
    margin-left: 290px;
  }
}
</style>
